import React, { useContext, useState } from "react";
import { Tabs, Tab, Box, Paper } from "@mui/material";
import LeaveReq from "./Biggbarains/LeaveReq";
import TotalLeave from "./Biggbarains/TotalLeave";
import PunishedLeave from "./PunishedLeave";
import AuthContext from "../store/AuthContext";

const EmployeeLeave = () => {
  const [activeTab, setActiveTab] = useState(0);
  const authCtx = useContext(AuthContext);
  const user = authCtx.user;
  return (
    <Box sx={{ width: "100%" }}>
      <Paper
        elevation={3}
        sx={{
          display: "flex",
          justifyContent: "center",
          p: 1,
          borderRadius: "12px",
          mt: 3,
          backgroundColor: "#f5f5f5",
        }}
      >
        <Tabs
          value={activeTab}
          onChange={(e, newValue) => setActiveTab(newValue)}
          TabIndicatorProps={{ style: { display: "none" } }}
          sx={{
            "& .MuiTab-root": {
              fontWeight: 600,
              textTransform: "none",
              borderRadius: "8px",
              mx: 1,
              px: 4,
              py: 1,
              transition: "all 0.3s ease",
              color: "#0b0c10",
            },
            "& .Mui-selected": {
              backgroundColor: "#2F3B57",
              color: "#fff",
            },
            "& .MuiTab-root:hover": {
              backgroundColor: "#b2dfdb",
            },
          }}
        >
          <Tab label="Leave Request" />
          <Tab label="Employee Leave" />
          {user.role === "Admin" && <Tab label="Punished Leave" />}
        </Tabs>
      </Paper>

      <Box mt={2}>
        {activeTab === 0 && <LeaveReq />}
        {activeTab === 1 && <TotalLeave />}
        {activeTab === 2 && <PunishedLeave />}
      </Box>
    </Box>
  );
};

export default EmployeeLeave;
